export default __webpack_public_path__ + "static/media/arrow-right-yellow.ed335c5f.svg";